import { formatPrice } from "./priceUtils";

export const avgPrice = (prices=[], areas=[]) => {
    const totalPrice = prices.reduce((sum, price) => sum + price, 0);
    const totalArea = areas.reduce((sum, area) => sum + area, 0);

    const averagePrice = totalArea > 0 ? totalPrice / totalArea : 0; // Prevent division by zero

    return ` ${formatPrice(averagePrice.toFixed(2))} /Sq.Ft.`;
};
